import { useAgencyCampaignContext } from './agencyCampaignContext';
import { createDemandClient } from '../agency/demandApi';
import { defaultBrandsFilter } from './brands/model';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { readShigoAppConfig } from '../../lib/config';
import { createShigoApiClient } from '../../lib/shigo-api-client';
import { useShigoSession } from '../../lib/useShigoSession';

const campaignBrandOptionSchema = z.looseObject({ id: z.string(), name: z.string() });

export function useCampaignBrandOptions(enabled = true) {
  const scope = useAgencyCampaignContext();
  const { session } = useShigoSession();
  const config = readShigoAppConfig();
  if (!session) throw new Error('Shigo session is required.');
  const api = createShigoApiClient(
    { apiBaseUrl: config.madSenseServiceUrl, networkId: config.networkId },
    session.accessToken,
  );
  return useQuery({
    enabled,
    queryKey: [
      ...(scope ? ['agency-demand', config.networkId, scope.agency.id] : []),
      'campaigns',
      'brand-options',
    ],
    queryFn: async () => {
      if (!scope)
        return api.request({ path: '/brands/all', schema: z.array(campaignBrandOptionSchema) });
      const client = createDemandClient({
        config: { apiBaseUrl: config.apiBaseUrl, networkId: config.networkId },
        accessToken: session.accessToken,
        agencyId: scope.agency.id,
      });
      const content = [];
      for (let page = 0; ; page++) {
        const result = await client.brands.list({ ...defaultBrandsFilter, page, size: 100 });
        content.push(...result.content);
        if (!result.content.length || content.length >= result.totalElements) return content;
      }
    },
  });
}
